import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

export const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="exception-body notfound">
            <div className="exception-panel">
                <div className="exception-content">
                    <img src="assets/layout/images/pages/icon-404.svg" alt="roma" />
                    <h1>Nema stranice</h1>
                </div>
            </div>
            <img alt="dzontravolta" style={{ position: 'absolute', right: '0px', bottom: '0px', width: '300px' }} src="assets/travolta.gif"></img>
        </div>
    );
};
